import {
  CONFIG_DATA,
  SET_ACTID
} from './types'

export default {
  [CONFIG_DATA](state, configData) {
    if (configData.actid) {
      let rewardImages = configData.rewardImages ? configData.rewardImages.split(',') : []
      state.rewardImages = rewardImages
      state.actid = configData.actid
      state.headImg = configData.imagePath
      state.bgColor = configData.pageColor

      state.rules = configData.rule.split('|')
      state.ruleBgColor = configData.ruleBackColor
      state.ruleColor = configData.rulerColor

      state.bottonBgColor = configData.bottonColor
      state.bottonWords = configData.bottonWords
      state.bottonWordsColor = configData.bottonWordsColor

      state.circle = configData.circle
      state.underColor = configData.underColor
      state.underWords = configData.underWords

      state.shareConfig = {
        title: configData.shareMainTitle,
        desc: configData.shareSubTile,
        imgUrl: configData.shareImage
      }
    }
  },
  [SET_ACTID](state, actid) {
    state.actid = actid
  }
}



// WEBPACK FOOTER //
// ./src/projects/vipCard/pages/receiveFree/store/mutations.js